import { Grid, InputAdornment, TextField } from "@mui/material";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { SUPPORTED_LANGUAGES } from "../hooks/useLanguage";
import { getFlagPathToLocale, LOCALE_KEYS } from "../utils/lib";

/**
 * Single translation-text-field.
 * Access to value through ref: ref.getValue() | ref.getLanguage()
 */
const SingleTranslationTextField = forwardRef(({ language, defaultValue, isStatic }, ref) => {
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  useImperativeHandle(ref, () => ({
    // returns the translation
    getValue: () => value,
    // returns the language
    getLanguage: () => language
  }));

  const textFieldStyle = {
    width: '90%'
  };

  return (
    <Grid item spacing={2} container alignItems="center" xs={12} >
      <Grid item xs={12}>
        <TextField
          InputLabelProps={{ shrink: true }}
          variant="outlined"
          size="small"
          name={"key " + language}
          label={"Name " + language.toUpperCase()}
          type="text"
          sx={textFieldStyle}
          value={value || ''}
          onChange={(event) => setValue(event.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <img src={getFlagPathToLocale(language)} alt="US Flag" style={{ width: 24, height: 16 }} />
              </InputAdornment>
            ),
          }}
          disabled={isStatic}
          inputProps={{ maxLength: 50 }}
        />
      </Grid>
    </Grid>
  )
});

/**
 * A list of text-fields for translations.
 * Access to values possible through ref.
 * ref.getTranslations(): returns object with all translations
 */
const TranslationTextFields = forwardRef(({ defaultTranslations, isStatic = false }, ref) => {
  const refs = useRef({});

  /**
   * The methods that are given to the outside-world through the ref.
   */
  useImperativeHandle(ref, () => ({
    getTranslations: () => {
      const obj = {};
      for (const lang in refs.current) {
        obj[lang] = refs.current[lang].getValue();
      }
      return obj;
    }
  }));

  return (
    <Grid item container spacing={2}>
      {LOCALE_KEYS.map(language => {
        return <Grid key={language} item container spacing={2} xs={12} sm={6} md={4}>
          <SingleTranslationTextField language={language} defaultValue={defaultTranslations[language]}
            ref={(el) => (refs.current[language] = el)} isStatic={isStatic} />
        </Grid>
      })}
    </Grid>
  )
});

export default TranslationTextFields;